module.exports = __webpack_public_path__ + "static/media/galeryFloating9.10f892bf.jpg";